/**
 * VÉNORA — reliable mobile header (menu / search / cart) + minicart remove
 */
(function () {
  'use strict';

  var cartRemoveTouched = false;
  var cartBindingsDone = false;

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function setOpen(el, bg, bodyClass, open) {
    if (!el) return;
    el.classList.toggle('active', open);
    if (bg) bg.classList.toggle('active', open);
    if (bodyClass) document.body.classList.toggle(bodyClass, open);
  }

  function isOpen(el) {
    return el && el.classList.contains('active');
  }

  function closeMenu() {
    setOpen(qs('.box_contentmenu'), qs('.box_contentmenu_background'), 'activemenu_mobile', false);
    qs('.menuleft')?.classList.remove('active');
  }

  function toggleMenu() {
    const menu = qs('.box_contentmenu');
    if (!menu) return;
    const open = !isOpen(menu);
    setOpen(menu, qs('.box_contentmenu_background'), 'activemenu_mobile', open);
    qs('.menuleft')?.classList.toggle('active', open);
  }

  function closeSearch() {
    setOpen(qs('.js-box-search'), qs('.bg_search_box'), 'activedestop', false);
  }

  function toggleSearch() {
    const box = qs('.js-box-search');
    if (!box) return;
    const open = !isOpen(box);
    setOpen(box, qs('.bg_search_box'), 'activedestop', open);
  }

  function closeCart() {
    setOpen(qs('.js-minicart'), qs('.bg-minicart'), null, false);
  }

  function toggleCart() {
    const cart = qs('.js-minicart');
    if (!cart) return;
    const open = !isOpen(cart);
    setOpen(cart, qs('.bg-minicart'), null, open);
    if (open) refreshMinicart();
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.money_format || '${{amount}}');
    }
    return (cents / 100).toFixed(2);
  }

  function updateCartCounts(cart) {
    document.querySelectorAll('.enj-cartcount').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function renderEmptyMinicart(container) {
    container.innerHTML =
      '<div class="list_product_minicart empty">' +
      '<div class="empty-product_minicart">' +
      '<p class="mb-0">Your shopping bag is empty</p>' +
      '<a href="/collections/all" class="to-cart">Shop now</a>' +
      '</div></div>';
  }

  function renderMinicartFromTemplate(cart, container) {
    var templateEl = document.getElementById('CartTemplate');
    if (!templateEl || typeof Handlebars === 'undefined') {
      if (cart.item_count === 0) {
        renderEmptyMinicart(container);
      }
      return false;
    }

    var template = Handlebars.compile(templateEl.innerHTML);
    var items = cart.items.map(function (cartItem, index) {
      var prodImg =
        cartItem.image != null
          ? cartItem.image.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '')
          : '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';

      return {
        id: cartItem.variant_id,
        line: index + 1,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: formatMoney(cartItem.price),
        vendor: cartItem.vendor,
      };
    });

    container.innerHTML = template({
      items: items,
      note: cart.note,
      totalPrice: formatMoney(cart.total_price),
    });
    return true;
  }

  function refreshMinicart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartCounts(cart);
        var container = qs('.enj-minicart-ajax');
        if (!container) return cart;

        if (cart.item_count === 0) {
          renderEmptyMinicart(container);
          return cart;
        }

        if (!renderMinicartFromTemplate(cart, container)) {
          if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
            try {
              ajaxCart.load();
            } catch (err) {
              /* ignore */
            }
          }
        }

        if (typeof jQuery !== 'undefined') {
          jQuery(document.body).trigger('ajaxCart.afterCartLoad', cart);
        }
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function changeCartLine(line, quantity) {
    var body = new URLSearchParams();
    body.set('line', String(line));
    body.set('quantity', String(quantity));

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
      body: body.toString(),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart change failed');
      return res.json();
    });
  }

  function findRemoveButton(target) {
    if (!target || !target.closest) return null;
    return target.closest('a.remove-product, .produc_remove a');
  }

  function isInMinicart(el) {
    return !!(el && (el.closest('.js-minicart') || el.closest('.minicart')));
  }

  function removeCartLine(line) {
    if (!line) return;
    changeCartLine(line, 0).then(function () {
      return refreshMinicart();
    });
  }

  function onCartRemove(e) {
    var removeBtn = findRemoveButton(e.target);
    if (!removeBtn || !isInMinicart(removeBtn)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var line = removeBtn.getAttribute('data-line');
    if (!line && typeof jQuery !== 'undefined') {
      line = jQuery(removeBtn).data('line');
    }
    removeCartLine(line);
  }

  function onHeaderActivate(e) {
    var header = qs('.menu_moblie');
    if (!header || !header.contains(e.target)) return;

    var menuBtn = e.target.closest('.menuleft');
    var searchBtn = e.target.closest('.js-search-destop');
    var cartBtn = e.target.closest('.js-call-minicart');

    if (!menuBtn && !searchBtn && !cartBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (menuBtn) toggleMenu();
    else if (searchBtn) toggleSearch();
    else if (cartBtn) toggleCart();
  }

  function onDocumentClick(e) {
    if (findRemoveButton(e.target)) return;

    if (e.target.closest('.box_contentmenu_background')) {
      closeMenu();
      return;
    }
    if (e.target.closest('.bg_search_box')) {
      closeSearch();
      return;
    }
    if (e.target.closest('.bg-minicart')) {
      closeCart();
      return;
    }
    if (e.target.closest('.js-drawer-close')) {
      closeSearch();
      return;
    }
    if (e.target.closest('.close-mini-cart')) {
      closeCart();
      return;
    }
    if (e.target.closest('.js-eveland-close')) {
      closeMenu();
    }
  }

  function bindCartRemove() {
    if (cartBindingsDone) return;
    cartBindingsDone = true;

    document.addEventListener(
      'click',
      function (e) {
        if (cartRemoveTouched) {
          cartRemoveTouched = false;
          return;
        }
        onCartRemove(e);
      },
      true
    );

    document.addEventListener(
      'touchend',
      function (e) {
        if (!findRemoveButton(e.target)) return;
        cartRemoveTouched = true;
        onCartRemove(e);
        window.setTimeout(function () {
          cartRemoveTouched = false;
        }, 500);
      },
      { capture: true, passive: false }
    );
  }

  function bindHeader() {
    var header = qs('.menu_moblie');
    if (!header || header.dataset.vnMobileBound === '1') return;
    header.dataset.vnMobileBound = '1';

    var touchHandled = false;

    header.addEventListener(
      'touchend',
      function (e) {
        touchHandled = true;
        onHeaderActivate(e);
        window.setTimeout(function () {
          touchHandled = false;
        }, 500);
      },
      { capture: true, passive: false }
    );

    header.addEventListener(
      'click',
      function (e) {
        if (touchHandled) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        onHeaderActivate(e);
      },
      true
    );

    document.addEventListener('click', onDocumentClick);
  }

  function bind() {
    bindCartRemove();
    bindHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
